/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Open_Team_Project_ToastInputs */

const en_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opening team project via share code...`)
};

const fr_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture du projet d'equipe via le code de partage...`)
};

const de_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eröffnung des Teamprojekts über ShareCode...`)
};

const it_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apertura del progetto di gruppo tramite codice di condivisione...`)
};

const ru_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытие командного проекта с помощью общего кода...`)
};

const es_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abriendo proyecto de equipo a través de código compartido...`)
};

const zh_cn2_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过共享代码打开团队项目……`)
};

const ja_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有コード経由でチーム プロジェクトを開いています...`)
};

const hi_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेयर कोड के माध्यम से टीम प्रोजेक्ट शुरू करना...`)
};

const pt_pt2_explorer_table_open_team_project_toast = /** @type {(inputs: Explorer_Table_Open_Team_Project_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrindo projeto de equipe via código de compartilhamento...`)
};

/**
* | output |
* | --- |
* | "Opening team project via share code..." |
*
* @param {Explorer_Table_Open_Team_Project_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_open_team_project_toast = /** @type {((inputs?: Explorer_Table_Open_Team_Project_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Open_Team_Project_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_open_team_project_toast(inputs)
	if (locale === "de") return de_explorer_table_open_team_project_toast(inputs)
	if (locale === "it") return it_explorer_table_open_team_project_toast(inputs)
	if (locale === "ru") return ru_explorer_table_open_team_project_toast(inputs)
	if (locale === "es") return es_explorer_table_open_team_project_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_open_team_project_toast(inputs)
	if (locale === "ja") return ja_explorer_table_open_team_project_toast(inputs)
	if (locale === "hi") return hi_explorer_table_open_team_project_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_open_team_project_toast(inputs)
	return en_explorer_table_open_team_project_toast(inputs)
});